import React from 'react';
import styled from 'styled-components';
import {Menu} from '@styled-icons/boxicons-regular/Menu';
import {User} from '@styled-icons/boxicons-regular/User';
import {CartAlt} from '@styled-icons/boxicons-regular/CartAlt';
import {useOutlet, useOutletSetter} from 'reconnect.js';
import useGlobalOutlets from '../../Hooks/useGlobalOutlets';
import * as NavUtil from '../../Utils/NavUtil';
import MobileNavDrawer from './MobileNavDrawer';
import NavLink from '../NavLink';
import * as AppActions from './../../AppActions';
import * as Ant from 'antd';
import useScrollBreakpoint from '../../Hooks/useBreakPoint';

// seasonbakery custom

const iconSize = 26;

const Config = require('../../../data.json');
const F = AppActions.F;

const SiteNavBar = (props) => {
  useGlobalOutlets();

  const {location} = props;
  const [dimension] = useOutlet('dimension');
  useOutlet('navbarConfig');
  const showLoginModal = useOutletSetter('login-modal');
  const [cart] = useOutlet('cart');
  const [user] = useOutlet('user');
  const [mobileNavVisible, setMobileNavVisible] = React.useState(false);
  const navItems = NavUtil.getNavItems(props);
  const rwd = true;
  // dimension.rwd !== 'desktop' ||
  // (navItems.length >= 5 && dimension.innerWidth <= 1150);

  const {passBreakpoint} = useScrollBreakpoint(40);
  const isLanding = location.pathname === '/';

  React.useEffect(() => {
    setMobileNavVisible(false);
  }, [location?.pathname]);

  const mobileNavItemContent = (
    <div className="nav-items">
      {navItems.map((navItem, idx) => {
        const selected = NavUtil.isNavLinkSelected(navItem);

        return (
          <React.Fragment key={idx}>
            <NavLink
              {...NavUtil.getNavLinkExtraProps(navItem)}
              to={navItem.path}
              className={selected ? `default selected ` : `default`}>
              <span>{F(navItem, 'name')}</span>
            </NavLink>
            {(navItem.entries || []).map((item, i) => (
              <NavLink
                {...NavUtil.getNavLinkExtraProps(item)}
                to={item.path}
                key={`item-${i}`}
                className={`default-child`}>
                <span>{F(item, 'name')}</span>
              </NavLink>
            ))}
          </React.Fragment>
        );
      })}
    </div>
  );

  return (
    <Wrapper
      className={[
        passBreakpoint ? 'solid' : '',
        isLanding ? 'landing' : '',
      ].join(' ')}>
      <div className="maxwidth-container">
        <div className="left">
          <button
            className="menu-btn-box nav-round-btn-box"
            onClick={() => setMobileNavVisible(true)}>
            <svg width={iconSize} height={iconSize}>
              <use xlinkHref="/images/icon-menu.svg#_圖層_2" />
            </svg>
          </button>
        </div>

        <div className="center">
          <button
            className="nav-round-btn-box"
            onClick={() => AppActions.navigate('/')}>
            <svg width="200" height="26" className="logo">
              <use xlinkHref="/images/logo.svg#_圖層_2" />
            </svg>
          </button>
        </div>
        <div className="right">
          <button
            className="menu-btn-box nav-round-btn-box"
            onClick={async () => {
              if (user) {
                await AppActions.navigate('/checkout', {loading: 500});
              } else {
                Ant.message.info(AppActions.L('login_first'));
              }
            }}>
            <svg width={iconSize} height={iconSize}>
              <use xlinkHref="/images/icon-cart.svg#_圖層_2" />
            </svg>

            {cart?.items?.length > 0 && (
              <div className="badge">{cart.items.length}</div>
            )}
          </button>
          <button
            className="menu-btn-box nav-round-btn-box"
            onClick={async () => {
              if (user) {
                await AppActions.navigate('/profile', {loading: 500});
              } else {
                showLoginModal(true);
              }
            }}>
            <svg width={iconSize} height={iconSize}>
              <use xlinkHref="/images/icon-profile.svg#_圖層_2" />
            </svg>
          </button>
        </div>
      </div>

      <MobileNavDrawer
        visible={rwd && mobileNavVisible}
        setVisible={setMobileNavVisible}
        {...props}>
        {mobileNavItemContent}
      </MobileNavDrawer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  background-color: var(--background-color);
  border-bottom: 0.7px solid var(--border-color);
  top: 0px;
  left: 0px;
  width: 100vw;
  height: var(--topNavBarHeight);
  padding: 0px 50px;
  transition: all 0.4s ease-out;

  display: flex;
  align-items: center;

  z-index: 101;
  //box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

  &:hover {
    //box-shadow: 0 5px 12px rgba(0, 0, 0, 0.16);
  }

  &.landing {
    background-color: transparent;
    border-bottom: 2px solid #78b0e9;
  }
  &.solid {
    background-color: var(--background-color);
  }
  &.landing.solid {
    background-color: #215aa8;
  }

  & > .maxwidth-container {
    display: flex;
    align-items: center;
    max-width: var(--contentMaxWidth);
    width: 100%;
    margin: 0 auto;

    & > .left {
      flex: 1;
      display: flex;
      justify-content: flex-start;
    }
    & > .center {
      display: flex;
      align-items: center;
    }
    & > .right {
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }
  }

  & > .maxwidth-container .menu-btn-box {
    padding: 8px;
    cursor: pointer;

    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }

  & .nav-round-btn-box {
    background-color: transparent;
    outline: none;
    border: none;
    box-shadow: none;
    display: flex;
    align-items: center;

    & > svg {
      color: var(--icon-color);
      fill: var(--icon-color);
    }
  }
  &.landing .nav-round-btn-box > svg {
    color: #fff;
    fill: #fff;
  }
  & svg.logo {
    color: var(--primaryColor);
    fill: var(--primaryColor);
  }
  &.landing svg.logo {
    color: #fff;
    fill: #fff;
  }
  & .badge {
    margin: 0 10px;
    font-weight: 600;
    color: var(--icon-color);
  }
  &.landing .badge {
    color: #fff;
  }

  @media (max-width: 768px) {
    padding: 20px;

    & .nav-round-btn-box {
      justify-content: center;
    }
  }
`;

export default SiteNavBar;
